<div class="row g-1">
  <div class="col-6">
    <p class="xsmall text-muted">Question</p>
  </div>
  <div class="col-3">
    <p class="xsmall text-muted">Student's answer</p>
  </div>
  <div class="col-3">
    <p class="xsmall text-muted">Correct answer</p>
  </div>
</div>
<div *ngFor="let q of questions" class="row">
  <div class="col-6">
    <p *ngIf="getQuestion(q)" class="small">{{ getQuestion(q) }}</p>
    <p *ngIf="!getQuestion(q)" class="small fst-italic">no audio transcription</p>
  </div>
  <div class="col-3">
    <p class="small" [ngClass]="{ 'text-danger': isAnswerIncorrect(q)}">{{ getStudentAnswer(q) }}</p>
  </div>
  <div class="col-3">
    <p class="small">{{ getCorrectAnswer(q) }}</p>
  </div>
</div>
